import { useUserStore } from '../../stores/userStore';
import { badgeKey } from './useBadges';

// Requests and publication share a per-client/account queue. A check cannot return
// an old representative mark after a selection that started while it was pending.
const queues = new WeakMap();
export function runBadgeCollectionTask(client, userId, task) {
  let accounts = queues.get(client);
  if (!accounts) {
    accounts = new Map();
    queues.set(client, accounts);
  }
  const previous = accounts.get(userId);
  const result = previous ? previous.then(task) : (async () => task())();
  const settled = result.then(
    () => undefined,
    () => undefined,
  );
  accounts.set(userId, settled);
  void settled.then(() => {
    if (accounts.get(userId) === settled) accounts.delete(userId);
  });
  return result;
}

// Caller must verify its request/session immediately before publication.
export function publishBadgeCollection(client, userId, next) {
  client.setQueryData(badgeKey(userId), next);
  const user = useUserStore.getState().user;
  if (user?.id !== userId || !['NONE', 'ACTIVITY', 'SPONSORSHIP'].includes(next.profileMarkType))
    return false;
  const mark = {
    ...user.profileMark,
    type: next.profileMarkType,
    activityBadge: next.profileMarkType === 'ACTIVITY' ? (next.featuredBadge ?? null) : null,
    sponsorshipLevel:
      next.profileMarkType === 'SPONSORSHIP'
        ? (next.sponsorshipMark?.currentStage?.level ?? 0)
        : null,
  };
  if (JSON.stringify(mark) === JSON.stringify(user.profileMark)) return false;
  useUserStore.setState({ user: { ...user, profileMark: mark } });
  return true;
}
